import { render } from "./supplier.vue?vue&type=template&id=25b702b8&scoped=true"
import script from "./supplier.vue?vue&type=script&lang=js"
export * from "./supplier.vue?vue&type=script&lang=js"

import "./supplier.vue?vue&type=style&index=0&id=25b702b8&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b702b8"]])

export default __exports__